import { ChatCircleDots, CaretRight } from "@phosphor-icons/react";
import { FADE_UP, motion, stagger, formatDateShort } from "./constants";

export default function UnreadCheckinsCard({ items, onNavigate }) {
  if (!items?.length) return null;
  const total = items.reduce((s, x) => s + x.count, 0);

  return (
    <div className="stat-card lg:col-span-2" data-testid="unread-checkins-card">
      <div className="flex items-center justify-between mb-4">
        <h3
          className="text-lg font-bold tracking-tight uppercase text-white flex items-center gap-2"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          <ChatCircleDots size={18} weight="fill" className="text-[#FF3B30]" />
          DA LEGGERE · CHECK-IN
          <span className="text-[11px] px-2 py-0.5 bg-[#FF3B30]/15 text-[#FF3B30] rounded-full font-bold normal-case tracking-normal">
            {total}
          </span>
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {items.map((u, i) => (
          <motion.button
            key={u.client_id}
            {...FADE_UP}
            transition={stagger(0.05, 0.04, i)}
            onClick={() => onNavigate(`/clients/${u.client_id}?tab=checkin`)}
            className="text-left p-3 rounded-lg bg-[#0A0A0A] border border-[#1A1A1A] hover:border-[#FF3B30]/40 hover:bg-[#FF3B30]/5 transition-all group flex items-center gap-3"
            data-testid={`unread-checkin-${u.client_id}`}
          >
            <div className="relative w-8 h-8 rounded-full bg-[#FF3B30]/15 flex items-center justify-center text-[#FF3B30] flex-shrink-0">
              <ChatCircleDots size={14} weight="fill" />
              <span className="absolute -top-1 -right-1 min-w-[15px] h-[15px] px-1 rounded-full bg-[#FF3B30] border-2 border-[#171717] text-white text-[8px] font-bold flex items-center justify-center leading-none">
                {u.count > 9 ? "9+" : u.count}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-white truncate group-hover:text-[#FF3B30] transition-colors">
                {u.client_name}
              </p>
              <p className="text-[10px] text-zinc-500">
                {u.count === 1 ? "1 check-in nuovo" : `${u.count} check-in nuovi`}
                {u.last_submitted_at && ` · ${formatDateShort(u.last_submitted_at)}`}
              </p>
            </div>
            <CaretRight size={14} className="text-zinc-600 group-hover:text-[#FF3B30] transition-colors flex-shrink-0" />
          </motion.button>
        ))}
      </div>
    </div>
  );
}
